export default __webpack_public_path__ + "static/media/office_web-lg@2x.5e38276e.jpg";